export default __webpack_public_path__ + "static/millingmachine-comp-23f0d7f35794df41513e591e7262783e.mp4";